import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NorwayCaseSummary } from '../interfaces/norwayCaseSummary.interface';
import { NorgeApplicationResult } from '../interfaces/norgeApplicationResult.interface';

@Injectable()
export class NorgeApplicationService {
  public selectedCase: NorwayCaseSummary | null = null;

  constructor(
    private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  public searchCases(query: string): Observable<NorwayCaseSummary[]> {
    return this.http.get<NorwayCaseSummary[]>(`${this.apiUrl}/GarantiKontrollNorge/SearchCases`, { params: { query } });
  }

  public submitApplication(application: unknown, files: File[]): Observable<NorgeApplicationResult> {
    const formData = new FormData();

    formData.append('application', JSON.stringify(application));

    for (const file of files) {
      formData.append('annenDokumentasjon', file, file.name);
    }

    return this.http.post<NorgeApplicationResult>(`${this.apiUrl}/NorwegianApplication/Submit`, formData).pipe(
      map(result => {
        if (!result?.referenceNumber) {
          throw new Error('Submit returned an empty reference number');
        }
        return result;
      })
    );
  }
}
